import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
//Defining initial state
export const initialState = {
    formChanged: false,
    saveChangesOpen: false,
    backClicked: false,
};
export const SettingsContext = createContext(undefined);
// Creating a custom hook to access the context
export function useSettingsContext() {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('settingContext must be used within an SettingsContextProvider');
    }
    return context;
}
// Creating a provider component
export const SettingsContextProvider = ({ children }) => {
    const [settingsContextState, setSettingsContextState] = useState(initialState);
    const updateSettingsContextState = (values) => {
        setSettingsContextState({ ...settingsContextState, ...values });
    };
    const contextValue = {
        settingsContextState,
        updateSettingsContextState,
    };
    return _jsx(SettingsContext.Provider, { value: contextValue, children: children });
};
